import { useMutation } from "@tanstack/react-query";
import { PaymentService } from "@/api/services/PaymentService";

export const useValidateCoupon = () => {
    const result = useMutation({
        mutationFn: ({ couponCode, childFrameId }: { couponCode: string, childFrameId: string }) => PaymentService.paymentControllerValidateCoupon({ couponCode: couponCode, childFrameId }),
    });

    return result;
}